import { Injectable } from '@angular/core';
import { NotificationBaseService } from '@core/services/notification-base.service';

@Injectable()
export class OrgNotificationService extends NotificationBaseService {
  protected apiUrl = '/org/api/v1';
}
